// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 717 ? "e6b68d76" : chunkId) + "." + {"717":"609f398215b1b14e","843":"c6c75e87ac660c55"}[chunkId] + ".js";
};